import { matchSorter } from 'match-sorter';
import omitBy from 'lodash/omitBy';

export const applyFilters = (data = [], filters = {}) => {
    const matchers = buildMatchers(filters);

    return Object.keys(matchers)
        .reduce(
            (result, filterName) => matchers[filterName](result),
            data
        );
};

const opts = (keys) => ({ keys, threshold: matchSorter.rankings.CONTAINS ,sorter: d => d });

function buildMatchers (filters = { }) {
    let matchers = {
        lender: data => matchSorter(data, filters.lender, opts(['lenderName'])),
        address: data => matchSorter(data, filters.address, opts(['lenderStreetAddress'])),
        zipcode: data => matchSorter(data, filters.zipcode, opts(['lenderZip'])),
        city: data => matchSorter(data, filters.city, opts(['lenderCity'])), 
        state: data => matchSorter(data, filters.state, opts(['lenderState']))         
    };

    return omitBy(matchers, (_, key) => !filters[key]);
}
